import React from "react";
import { useTranslation } from "react-i18next";
import Event from "../../../../../../core/consts/analytics-events";
import styles from "./intro.module.scss";
import { useDI } from "../../../../../../core/di";

export function Intro() {
  const { t } = useTranslation();
  const { analytics } = useDI();

  const handleContactUsClicked = () => {
    analytics?.track(Event.CancelSubscriptionContactUsClicked);
  };

  return <p className={styles.Paragraph}>{t("cancelSubscriptionIntro")}</p>;
}

export default Intro;
